<script setup lang="ts">
  import { computed } from 'vue';
  import { ProgressBarAppearance } from './ProgressBar.types';

  interface ProgressBarProps {
    value: number;
    max?: number;
    appearance?: `${ProgressBarAppearance}`;
  }

  const props = withDefaults(defineProps<ProgressBarProps>(), {
    max: 100,
    appearance: ProgressBarAppearance.Neutral,
  });

  const percent = computed(() => (props.max > 0 ? Math.min(100, Math.max(0, (props.value / props.max) * 100)) : 0));
</script>

<template>
  <div class="tl-progress-bar">
    <div :class="['tl-progress-bar__fill', `tl-progress-bar__fill_${appearance}`]" :style="{ width: `${percent}%` }" />
  </div>
</template>

<style lang="scss">
  .tl-progress-bar {
    background-color: var(--color-neutral-30);
    border-radius: var(--rounding-s);
    overflow: hidden;
    width: 100%;

    &__fill {
      border-radius: var(--rounding-s);
      height: 4px;

      &_positive {
        background-color: var(--color-green-60);
      }

      &_negative {
        background-color: var(--color-orange-60);
      }

      &_neutral {
        background-color: var(--color-neutral-50);
      }
    }
  }
</style>
